export default "__VITE_ASSET__ygvxiM2N__"